export default __webpack_public_path__ + "assets/images/c8cd17d96223e42851bd7c0e4110725c.svg";